import cn from 'classnames';
import classNames from 'classnames';
import Image from 'next/image';
import Link from 'next/link';

import Button from '@/components/Button';
import SideCart from '@/components/Cart/SideCart/SideCart';
import LoginSidebar from '@/components/LoginSidebar';
import SearchBar from '@/components/SearchBar';
import { avenirFont } from '@/utils/font';
import medalIcon from 'public/icons/medal-icon.svg';
import patynaLogo from 'public/images/patyna_logo.svg';

import IconButton from '../IconButton';

import styles from './styles.module.scss';
import { Props } from './types';

const Topbar = ({
  className,
  dropdownClass,
  isSmallerLogo,
  isCentered,
  isMobile,
  onlyLogo,
}: Props) => {
  if (onlyLogo) {
    return (
      <>
        <div className={cn(className, styles.onlyLogo)}>
          <Link href="/">
            <Image
              className={cn(styles.logo)}
              src={patynaLogo}
              alt="Patyna - sklep z meblami i dekoracjami vintage"
              width={78}
              priority
            />
          </Link>
        </div>
      </>
    );
  }

  return (
    <div className={className}>
      <div className={styles.left}>
        <div className={styles.vendorButton}>
          <Button
            href={process.env.NEXT_PUBLIC_LOGIN_VENDOR_URL}
            isOutline
            isCapitalize
            variant="primary"
          >
            Sprzedawaj
          </Button>
        </div>
        <div className={styles.searchDesktop}>
          <SearchBar />
        </div>
      </div>
      <div
        className={cn(styles.right, {
          [styles.centered]: isCentered && !isMobile,
        })}
      >
        <div className={styles.leftCol}>
          <Link href="/">
            <Image
              className={cn(styles.logo, {
                [styles.smallerLogo]: isSmallerLogo && !isMobile,
              })}
              src={patynaLogo}
              alt="Patyna - sklep z meblami i dekoracjami vintage"
              width={78}
              priority
            />
          </Link>
        </div>
        <div className={styles.rightCol}>
          {/* {isVisible && (
            <div className={styles.foreign}>
              <Link href="/foreign-customers">
                <Image src={worldIcon} alt="Ikona świata" width={16} />
                <p>Foreign customers</p>
              </Link>
            </div>
          )} */}
          <div className={classNames(styles.iconsNav, avenirFont)}>
            <IconButton href="/patyna-b2-b">
              <Image src={medalIcon} alt="Ikona medalu" height={22} />
              <p>Patyna B2B</p>
            </IconButton>
            <LoginSidebar classNames={dropdownClass} />
            <SideCart />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Topbar;
